<template>
  <div>
    <header>
      <slot />
      <ButtonSwitch v-if="!empty && cluster" v-model="mapView" :options="{
        heatmap: $t('swee:dashboard.map.heatmap'),
        markers: $t('swee:dashboard.map.markers'),
      }" />
    </header>
    <div v-if="empty && loaded">{{ 'no_count' | trans }}</div>
    <Loading v-if="empty && !loaded" />
    <div class="map" ref="map"></div>
  </div>
</template>

<script>
  import Recordset from '@/providers/api/Recordset'
  import maps, {create_map} from '@/providers/maps'
  import MarkerClusterer from 'google-maps-utilities' //loads MarkerClusterer
  import ButtonSwitch from '@/helpers/components/interact/ButtonSwitch'

  import cluster1 from '@/apps/swee/assets/cluster/m1.png'
  import cluster2 from '@/apps/swee/assets/cluster/m2.png'
  import cluster3 from '@/apps/swee/assets/cluster/m3.png'
  import cluster4 from '@/apps/swee/assets/cluster/m4.png'
  import cluster5 from '@/apps/swee/assets/cluster/m5.png'
  import personmarker from '@/apps/swee/assets/participation-marker.png'
  
  export default {
    name: 'Map',
    components: {ButtonSwitch},
    props: {
      event: {required: false, type: Recordset},
      locations: {required: true},
      mapstyle: {type: Array, required: false},
    },
    data () {return {
      map: false,
      heatmap: false,
      cluster: false,
      mapView: 'heatmap',
    }},
    computed: {
      loaded () {
        return Array.isArray(this.locations);
      },
      empty () {
        return !this.locations || !this.locations.length;
      },
    },
    methods: {
      setupMap () {
        if (this.empty || this.map) {
          return;
        }
        var styles = this.mapstyle;
        var center;
        var zoom = Math.min(17, Math.max(9, Math.round(
          27 / (
            this.event ?
            Number(this.event.proximity_participation_km || 100) :
            100
          )
        )));
        if (this.event && (this.event.latitude || this.event.longitude)) {
          center = {
            lat: Number(this.event.latitude),
            lng: Number(this.event.longitude),
          };
        } else if (this.event && this.event.countries && this.event.countries.name) {
          center = {
            lat: 15,
            lng: 46,
          };
        } else {
          center = {
            lat: 15,
            lng: 46,
          };
        }
        this.map = create_map.call(this, {styles, center, zoom});
        this.map.wait.then(() => {
          this.heatmap = new google.maps.visualization.HeatmapLayer({
            data: [],
            radius: 30,
            map: this.map.map,
            gradient: [
              'rgba(255, 220, 131, 0)',
              '#FFDC83',
              '#FF7D77',
            ],
          });
        });
      },
      latlngs (parts = false) {
        if (parts === false) {
          parts = this.locations;
        }
        return parts
          .filter(p => p.length >= 2 && (p[0] || p[1]))
          .map(p => {
            var m = new google.maps.LatLng(
              Number(p[0]),
              Number(p[1]),
            );
            m.apilocation = {
              lat: p[0],
              lng: p[1],
            };
            return m;
          })
        ;
      },
      fillHeatmap () {
        this.$nextTick(() => {
          this.setupMap();
          if (!this.map) {
            return;
          }
          this.map.wait.then(() => {
            if (this.heatmap) {
              this.heatmap.setData(this.latlngs());
            }
          });
        });
      },
      onLoaded () {
        if (!this.loaded || !this.map) {
          return;
        }
        this.map.wait
          .then(() => {
            var latlngs = this.latlngs();
            if (!latlngs.length) {
              return;
            }
            var bounds = new google.maps.LatLngBounds();
            for (let latlng of latlngs) {
              bounds.extend(latlng);
            }
            var markers = latlngs.map(position => {
              var m = new google.maps.Marker({
                position,
                icon: personmarker,
              });
              m.addListener('click', () => this.$emit('marker', position.apilocation));
              return m;
            });
            this.map.map.fitBounds(bounds, 20);
            this.cluster = {
              cluster: new MarkerClusterer(
                this.map.map,
                [],
                {
                  styles: [cluster1, cluster2, cluster3, cluster4, cluster5].map(url => ({
                      url, height: 25, width: 25
                    })),
                }
              ),
              markers,
              show: function () {
                this.cluster.clearMarkers();
                this.cluster.addMarkers(markers);
              },
              hide: function () {
                this.cluster.clearMarkers();
              },
            };
          })
        ;
      }
    },
    watch: {
      empty () {
        this.setupMap();
      },
      loaded () {
        this.onLoaded();
      },
      locations: {
        deep: true,
        handler () {this.fillHeatmap();},
      },
      mapView (view) {
        if (!this.map.map) {
          return;
        }
        if (view === 'heatmap' && this.heatmap) {
          this.heatmap.setMap(this.map.map);
          if (this.cluster) {
            this.cluster.hide();
          }
        }
        if (view === 'markers' && this.cluster) {
          this.cluster.show();
          if (this.heatmap) {
            this.heatmap.setMap(null);
          }
        }
      },
    },
    mounted () {
      this.setupMap();
      this.fillHeatmap();
      this.onLoaded();
    },
  }
</script>

<style lang="scss" scoped>
  .map {
    height: 30vh;
    min-height: 400px;
  }
</style>



// WEBPACK FOOTER //
// src/helpers/components/display/Map.vue